// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AmazonCircleFilledSvg from "@ant-design/icons-svg/es/asn/AmazonCircleFilled";
import AntdIcon from '../components/AntdIcon';

var AmazonCircleFilled = function AmazonCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AmazonCircleFilledSvg
  }));
};

AmazonCircleFilled.displayName = 'AmazonCircleFilled';
export default React.forwardRef(AmazonCircleFilled);